var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare2 = function SvgShare2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M.769 19.444H.745a.553.553 0 0 1-.53-.558c.002-.136.32-13.463 13.292-13.831V1.169a.552.552 0 0 1 .902-.43l8.862 7.2a.556.556 0 0 1 .002.861L14.412 16a.56.56 0 0 1-.589.07.55.55 0 0 1-.316-.5v-3.873c-11.542.21-12.165 6.942-12.187 7.232a.55.55 0 0 1-.551.515"
  })));
};
export { SvgShare2 as ReactComponent };